import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";

function EditIntegration({ chimeraserv, user }) {
  const location = useLocation();
  const data = location.state?.data || {};
  const [form, setForm] = useState({
    outletId: { value: data.outletId || "", state: null },
    venueId: { value: data.venueId || "", state: null },
    username: { value: data.username || "", state: null },
    password: { value: data.password || "", state: null },
    expiryDate: { value: data.expiryDate || "", state: null },
    status: { value: data.status || "active", state: null },
    expiryAcknowledged: {
      value: data.expiryAcknowledged || false,
      state: null,
    },
    message: { value: "", state: null },
    state: false,
  });

  const checker = (state) => {
    const check = { icon: "check-circle", style: "null" };
    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }
    return check;
  };

  const handleChange = (e) => {
    let { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: { value: type === "checkbox" ? checked : value, state: true },
      message: { value: "", state: null },
    }));
  };

  const handleReset = () => {
    setForm({
      outletId: { value: "", state: null },
      venueId: { value: "", state: null },
      username: { value: "", state: null },
      password: { value: "", state: null },
      expiryDate: { value: "", state: null },
      status: { value: "active", state: null },
      expiryAcknowledged: { value: false, state: null },
      message: { value: "", state: null },
      state: false,
    });
  };

  const isFormValid =
    form.outletId.value &&
    form.username.value &&
    form.password.value &&
    form.expiryDate.value;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) return;
    try {
      await axios({
        method: "POST",
        url: chimeraserv.urlQlub + "/outlet-api-key",
        headers: {
          "x-auth-key": chimeraserv.qlubAuthKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: {
          outletId: form.outletId.value,
          type: "QLUBPAT",
          expiryDate: form.expiryDate.value,
          status: form.status.value,
          expiryAcknowledged: form.expiryAcknowledged.value,
        },
      });
      await axios({
        method: "POST",
        url: chimeraserv.urlQlub + "/outlet-user",
        headers: {
          "x-auth-key": chimeraserv.qlubAuthKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: {
          outletId: form.outletId.value,
          username: form.username.value,
          password: form.password.value,
        },
      });
      setForm((prev) => ({
        ...prev,
        message: { value: "Integration Created Successfully!", state: true },
      }));
    } catch (error) {
      setForm((prev) => ({
        ...prev,
        message: {
          value: error.response?.data?.message || "Error creating integration",
          state: false,
        },
        state: false,
      }));
    }
  };

  return (
    <div className="custForm">
      <Helmet>
        <title>Edit Qlub PAT Integration | Chimera Solutions | Insights</title>
      </Helmet>
      <div className="viewTitle">Edit Qlub PAT Integration</div>
      <form onSubmit={handleSubmit} className="form">
        {form.message.value && (
          <div
            className={`alert ${
              form.message.state ? "alert-success" : "alert-error"
            }`}
            style={{
              padding: "10px 15px",
              marginBottom: "15px",
              borderRadius: "4px",
              backgroundColor: form.message.state ? "#d4edda" : "#f8d7da",
              color: form.message.state ? "#155724" : "#721c24",
              border: `1px solid ${form.message.state ? "#c3e6cb" : "#f5c6cb"}`,
            }}
          >
            <FontAwesomeIcon
              icon={[
                "fas",
                form.message.state ? "check-circle" : "exclamation-circle",
              ]}
              style={{ marginRight: "8px" }}
            />
            {form.message.value}
          </div>
        )}

        <div className="form-group">
          <label>
            Outlet ID <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.outletId.state).style].join(" ")}
            icon={["fas", checker(form.outletId.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="outletId"
            value={form.outletId.value ?? ""}
            onChange={handleChange}
            placeholder="Enter Outlet ID"
          />
        </div>
        {/* <div className="form-group">
          <label>
            Venue ID <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.venueId.state).style].join(" ")}
            icon={["fas", checker(form.venueId.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="venueId"
            value={form.venueId.value ?? ""}
            onChange={handleChange}
            placeholder="Enter Venue ID"
          />
        </div> */}
        <div className="form-group">
          <label>
            Username <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.username.state).style].join(" ")}
            icon={["fas", checker(form.username.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="username"
            value={form.username.value ?? ""}
            onChange={handleChange}
            placeholder="Enter Username"
            autoComplete="off"
          />
        </div>
        <div className="form-group">
          <label>
            Password <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.password.state).style].join(" ")}
            icon={["fas", checker(form.password.state).icon]}
          />
          <input
            type="password"
            className="form-control"
            name="password"
            value={form.password.value ?? ""}
            onChange={handleChange}
            placeholder="Enter Password"
            autoComplete="new-password"
          />
        </div>
        <div className="form-group">
          <label>
            Expiry Date <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.expiryDate.state).style].join(" ")}
            icon={["fas", checker(form.expiryDate.state).icon]}
          />
          <input
            type="date"
            className="form-control"
            name="expiryDate"
            value={form.expiryDate.value ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Status</label>
          <select
            className="form-control"
            name="status"
            value={form.status.value ?? "active"}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        <div className="form-group">
          <label>
            <input
              type="checkbox"
              name="expiryAcknowledged"
              checked={form.expiryAcknowledged.value ?? false}
              onChange={handleChange}
              style={{ marginRight: "8px" }}
            />
            Expiry Acknowledged
          </label>
        </div>

        <div className="form-actions">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!isFormValid}
          >
            Update
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn btn-primary reset"
          >
            Reset
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditIntegration;
